import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { taxonomyProductsSearchSchema } from '~/features/taxonomy-studio/utils/taxonomy-search';

const ProductsPage = lazy(() => import('~/features/taxonomy-studio/pages/products-page'));

/** Taxonomy Studio — the product-type tree and a node's attributes. */
export const Route = createFileRoute('/_authenticated/_tenant/taxonomy/products')({
  validateSearch: taxonomyProductsSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ProductsPage />
    </Suspense>
  ),
});
